import styled from '@emotion/styled';
import {
  LinkType,
  Prismic,
  PrismicText,
  PrismicContext,
} from '@landsbankinn/prismic';
import { typography } from '@landsbankinn/ui';

import Link from 'next/link';
import React, { useContext } from 'react';
import { AnnualModule } from '../components/slices/AnnualModule';

function parseNumber(value: string) {
  return parseFloat(value?.replace(/,|\./g, (x) => (x === '.' ? '' : '.')));
}

function parseString(value: string) {
  value = value.replace(/\d/g, '').replace(',', '');
  return value == '.' ? '' : value;
}

const Button = styled.a`
  display: block;
  width: 400px;
  padding: 20px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  background-color: #fff;
  ${typography.body}
  text-align: center;
  transition: 330ms ease-in-out;
  transition-property: color, background-color;
  &:hover,
  &:active {
    background-color: ${(props) => props.theme.shades.primary1};
  }
`;

export function AnnualModuleContainer(props: any) {
  const { action_link, action_title, copy, charts, layout_type, fields } =
    props;

  const { urlResolver } = useContext(PrismicContext);
  const items = fields.map((field: any) => ({
    title: Prismic.text(field.a_title),
    value: layout_type == 'text' ? parseNumber(field.value) : field.value,
    suffix: parseString(field.value),
    percentage: parseNumber(field.percentage) / 100,
    chart: charts,
    type: layout_type,
  }));

  const link =
    action_link &&
    Prismic.link(
      urlResolver,
      {
        _linkType: LinkType.Document,
        ...action_link,
      },
      action_title,
    );

  return (
    <AnnualModule
      background={charts}
      type={layout_type}
      action={
        link && (
          <Link href={link.as}>
            <Button {...link.anchorProps()}>{link.title}</Button>
          </Link>
        )
      }
      copy={<PrismicText value={copy} />}
      items={items}
    />
  );
}
